// extracted by mini-css-extract-plugin
module.exports = {"addIntentContent":"add-intent_addIntentContent__11tEz","green":"add-intent_green__1UlMq","form":"add-intent_form__2x018","error":"add-intent_error__3u7JO"};